<i (click)="ToggleMenu()" class="clickable icon-menu"></i>
<div [class.active]="menuShow" class="sidebar">
	<div class="header">
		<button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="ToggleMenu()"></button>
	</div>
	<ul>
		<li><a href="javascript:void(0)" (click)="menuShow = false" [routerLink]="['/', 'dash']">My {{brand.fleetPlural}}</a></li>
		@if (api.user?.role === 'orgadmin' || api.user?.role === 'admin' || api.user?.role === 'master') {
			<li><a href="javascript:void(0)" (click)="menuShow = false" [routerLink]="['/', 'orgadmin', 'manage']">Organization Management</a></li>
		}
		@if (api.user?.role === 'orgadmin' || api.user?.role === 'admin' || api.user?.role === 'master') {
			<li><a href="javascript:void(0)" (click)="menuShow = false" [routerLink]="['/', 'orgadmin', 'log']">Organization Log</a></li>
		}
		<li><a href="javascript:void(0)" (click)="menuShow = false" [routerLink]="['/', 'dash', 'account']">Manage Account</a></li>
		@if (brand.fixedassets) {
			<li><a href="javascript:void(0)" (click)="menuShow = false" [routerLink]="['/', 'dash', 'support']">Support</a></li>
		}
		@if (!brand.fixedassets) {
			<li><a href="https://support.gpms-vt.com/knowledge">Knowledge Base</a></li>
		}
		@if (!brand.fixedassets) {
			<li><a href="https://support.gpms-vt.com/tickets-view">Customer Service Portal</a></li>
		}
		<li><a href="javascript:void(0)" (click)="Logout()">Log Out</a></li>
	</ul>
	@if (api.user?.role === 'admin' || api.user?.role === 'master') {
		<div>
			<div class="admin-header">Admin</div>
			<ul>
				<li><a href="javascript:void(0)" (click)="menuShow = false" [routerLink]="['/', 'admin', 'user']">Manage Users</a></li>
				<li><a href="javascript:void(0)" (click)="menuShow = false" [routerLink]="['/', 'admin', 'assets']">Manage All Assets</a></li>
				<li><a href="javascript:void(0)" (click)="menuShow = false" [routerLink]="['/', 'admin', 'config']">Manage Configs</a></li>
				<li><a href="javascript:void(0)" (click)="menuShow = false" [routerLink]="['/', 'admin', 'log']">System Log</a></li>
			</ul>
		</div>
	}
	@if (!(api.user?.role === 'admin' || api.user?.role === 'master') && api.user?.support) {
		<div>
			<div class="admin-header">Support</div>
			<ul>
				<li><a href="javascript:void(0)" (click)="menuShow = false" [routerLink]="['/', 'support', 'fleet']">Fleetwide Ops</a></li>
			</ul>
		</div>
	}
	<div class="branded-asset-spinner"></div>
	<div class="git-version">Client: {{clientVersion}}</div>
	<div class="git-version">Server: {{serverVersion}}</div>
</div>